module.exports = __webpack_public_path__ + "static/media/Quiero-Prestar.c79852c0.png";